import type { NewsArticle } from '../types/news';

export const news: NewsArticle[] = [
  {
    id: 'fepro-2026-e-a-grande-atracao-deste-domingo-em-friburgo',
    title: 'Fepro 2026 é a grande atração deste domingo em Friburgo',
    summary:
      'A FEPRO 2026, a maior Feira da Promoção em Nova Friburgo, termina neste domingo, 12 de abril, com expectativa de grande público no Nova Friburgo Country Clube.',
    eventSlug: 'fepro',
    image: 'https://novafriburgoemfoco.com.br/wp-content/uploads/2026/04/feprocapa-1.jpg',
    date: '2026-04-12',
    dateLabel: 'Abril 2026',
    source: 'Nova Friburgo em Foco',
    url: 'https://novafriburgoemfoco.com.br/fepro-2026-e-a-grande-atracao-deste-domingo-em-friburgo/',
  },
  {
    id: 'fepro-2026-tem-inicio-nesta-quarta-feira-no-country-clube',
    title: 'Fepro 2026 tem início nesta quarta-feira no Country Clube',
    summary:
      'A Fepro 2026 já tem data marcada e promete movimentar Nova Friburgo ao longo de cinco dias. O evento será realizado desta quarta-feira, 8, ao próximo domingo, 12, no Nova Friburgo Country Clube, reunindo comércio, entretenimento e opções de lazer em um só espaço.',
    eventSlug: 'fepro',
    image:
      'https://avozdaserra.com.br/sites/default/files/noticias/screenshot_20250318_202655_photos_marcelo-iezzi-1_0.jpg',
    date: '2026-04-07',
    dateLabel: 'Abril 2026',
    source: 'A Voz da Serra',
    url: 'https://avozdaserra.com.br/noticias/fepro-2026-tem-inicio-nesta-quarta-feira-no-country-clube',
  },
  {
    id: 'fepro-2026-movimenta-nova-friburgo',
    title: 'FEPRO 2026 movimenta Nova Friburgo com música, gastronomia e promoções',
    summary:
      'Consolidada como uma das principais feiras do estado, a FEPRO movimenta a economia local e oferece ao público uma experiência completa de compras e lazer. Entre os destaques da programação musical estão Maurício Mantena, Gui Alves, Junior Lima, Leandro Gomes, Irmãos WW, DJ Santtoz e The Cherry Rock.',
    eventSlug: 'fepro',
    image:
      'https://www.serranewsrj.com.br/wp-content/webp-express/webp-images/uploads/2026/04/fepro--1130x580.jpeg.webp',
    date: '2026-04-07',
    dateLabel: 'Abril 2026',
    source: 'Serra News',
    url: 'https://www.serranewsrj.com.br/2026/04/fepro-2026-movimenta-nova-friburgo.html',
  },
  {
    id: 'festa-do-morango-com-chocolate-comeca-nesta-quinta-feira-em-nova-friburgo',
    title: 'Festa do Morango com Chocolate começa nesta quinta-feira em Nova Friburgo',
    summary:
      'A 11ª edição da tradicional Festa do Morango com Chocolate de Nova Friburgo , Região Serrana do Rio, começa nesta quinta-feira (9) e segue até domingo (12), das13h às 22h no Nova Friburgo Country Clube. A expectativa da organização é de receber cerca de 55 mil visitantes durante os quatro dias de evento, que contará com mais de 60 expositores, atrações culturais, oficinas e uma feira de flores.',
    eventSlug: 'festa-do-morango-com-chocolate',
    image: '/images/morango.avif',
    date: '2025-10-09',
    dateLabel: 'Outubro 2025',
    source: 'G1',
    url: 'https://g1.globo.com/rj/regiao-serrana/noticia/2025/10/09/festa-do-morango-com-chocolate-comeca-nesta-quinta-feira-em-nova-friburgo.ghtml',
  },
  {
    id: 'friburgo-festas-do-morango-com-chocolate-e-da-flor-atraem-200-grupos-de-turistas',
    title: 'Friburgo: Festas do Morango com Chocolate e da Flor atraem 200 grupos de turistas',
    summary:
      'Até domingo, 12 de outubro, moradores e turistas podem curtir a 11ª edição da tradicional Festa do Morango com Chocolate de Nova Friburgo, que acontece paralelamente à Festa da Flor.',
    eventSlug: 'festa-do-morango-com-chocolate',
    image: 'https://novafriburgoemfoco.com.br/wp-content/uploads/2025/10/MORAGOCAPA-700x330.jpg',
    date: '2025-10-11',
    dateLabel: 'Outubro 2025',
    source: 'Nova Friburgo em Foco',
    url: 'https://novafriburgoemfoco.com.br/friburgo-festas-do-morango-com-chocolate-e-da-flor-atraem-200-grupos-de-turistas/',
  },
  {
    id: 'festa-do-morango-com-chocolate-de-nova-friburgo-chega-a-11-edicao-com-mais-experiencias-para-toda-a-familia',
    title:
      'Festa do Morango com Chocolate de Nova Friburgo chega à 11ª edição com mais experiências para toda a família',
    summary:
      'Entre os dias 09 e 12 de outubro, Nova Friburgo recebe sua tradicional Festa do Morango com Chocolate, que nesta 11ª edição levará ao público um roteiro repleto de atrações, que prometem agradar moradores e turistas. A cidade é a maior produtora de morangos do estado fluminense. No ano anterior, cerca de 45 mil pessoas prestigiaram o evento.',
    eventSlug: 'festa-do-morango-com-chocolate',
    image:
      'https://odia.ig.com.br/_midias/jpg/2025/10/01/1200x750/1_festa_do_morango_com_chocolate___6_-37150573.jpg',
    date: '2025-10-01',
    dateLabel: 'Outubro 2025',
    source: 'O Dia',
    url: 'https://odia.ig.com.br/nova-friburgo/2025/10/7138479-festa-do-morango-com-chocolate-de-nova-friburgo-chega-a-11-edicao-com-mais-experiencias-para-toda-a-familia.html',
  },
  {
    id: 'friburgo-nossa-feira-oferece-grandes-ofertas-e-boas-atracoes-artisticas-para-o-publico',
    title:
      'Friburgo: “Nossa Feira” oferece grandes ofertas e boas atrações artísticas para o público',
    summary:
      'A “Nossa Feira” une negócios, cultura, música e lazer. São dezenas de expositores locais de moda íntima, praia, fitness, infantil, masculina e feminina, além de brinquedos, utilidades, artesanato, serviços e gastronomia.',
    eventSlug: 'nossa-feira',
    image:
      'https://novafriburgoemfoco.com.br/wp-content/uploads/2025/09/nossafeiracapa1-700x328.jpg.webp',
    date: '2025-09-05',
    dateLabel: 'Setembro 2025',
    source: 'Nova Friburgo em Foco',
    url: 'https://novafriburgoemfoco.com.br/friburgo-nossa-feira-oferece-grandes-ofertas-e-boas-atracoes-artisticas-para-o-publico/',
  },
  {
    id: 'nossa-feira-retorna-ao-nova-friburgo-country-clube-nos-dias-3-a-7-de-setembro',
    title: 'Nossa Feira retorna ao Nova Friburgo Country Clube nos dias 3 a 7 de setembro',
    summary:
      'Após o sucesso na sua primeira edição, a Nossa Feira já tem data para voltar. De 3 a 7 de setembro, o evento retorna ao calendário da cidade com uma edição ainda mais atrativa, bonita e especial, reforçando sua proposta de ser um espaço feito por e para os friburguenses.',
    eventSlug: 'nossa-feira',
    image: 'https://descubranovafriburgo.com.br/wp-content/uploads/2025/08/nossa-feira-.jpg',
    date: '2025-08-27',
    dateLabel: 'Agosto 2025',
    source: 'Descubra Nova Friburgo',
    url: 'https://descubranovafriburgo.com.br/nossa-feira-retorna-ao-nova-friburgo-country-clube-nos-dias-3-a-7-de-setembro/',
  },
  {
    id: 'nossa-feira-retorna-a-nova-friburgo-em-setembro-com-edicao-ainda-mais-especial',
    title: 'Nossa Feira retorna a Nova Friburgo em setembro com edição ainda mais especial',
    summary:
      'Após o sucesso absoluto de público em sua primeira edição, a Nossa Feira já tem data para voltar a Nova Friburgo. De 3 a 7 de setembro de 2025, o evento que conquistou moradores da cidade retorna ao calendário local com uma edição ainda mais atrativa, bonita e especial, reforçando sua proposta de ser um espaço feito por e para friburguenses.',
    eventSlug: 'nossa-feira',
    image:
      'https://www.serranewsrj.com.br/wp-content/webp-express/webp-images/uploads/2025/08/nossa-feira-1-1130x580.jpg.webp',
    date: '2025-08-19',
    dateLabel: 'Agosto 2025',
    source: 'Serra News',
    url: 'https://www.serranewsrj.com.br/2025/08/nossa-feira-retorna-a-nova-friburgo-em-setembro-com-edicao-ainda-mais-especial.html',
  },
  {
    id: 'fepro-2025-reune-40-mil-pessoas-em-edicao-que-celebra-25-anos-de-incentivo-a-economia-em-nova-friburgo',
    title:
      'Fepro 2025 reúne 40 mil pessoas em edição que celebra 25 anos de incentivo à economia em Nova Friburgo',
    summary:
      'A 25ª edição da Feira da Promoção de Nova Friburgo, a Fepro 2025, chegou ao fim neste domingo (13) com recorde de público e balanço positivo para a cidade da Região Serrana do Rio, segundo os organizadores.Durante os cinco dias de evento, cerca de 40 mil pessoas visitaram o Nova Friburgo Country Clube, onde a feira foi realizada. Conhecida por reunir centenas de expositores com preços promocionais, a feira também ofereceu atrações culturais e um ambiente familiar, o que atraiu moradores e turistas de diversas regiões. O objetivo da Fepro também é fortalecer o comércio local.',
    eventSlug: 'fepro',
    image: '/images/fepro2025.avif',
    date: '2025-04-14',
    dateLabel: 'Abril 2025',
    source: 'G1',
    url: 'https://g1.globo.com/rj/regiao-serrana/noticia/2025/04/14/fepro-2025-reune-40-mil-pessoas-em-edicao-que-celebra-25-anos-de-incentivo-a-economia-em-nova-friburgo.ghtml',
  },
  {
    id: 'fepro-2025-comeca-nesta-quarta-feira-em-friburgo-com-shows-encontro-de-turismo-e-promocoes',
    title:
      'Fepro 2025 começa nesta quarta-feira em Friburgo com shows, encontro de turismo e promoções',
    summary:
      'A Feira da Promoção (Fepro) de Nova Friburgo, na Região Serrana do Rio, começa nesta quarta-feira, 9, e segue até o domingo, 13, com diversas ofertas, shows e atrações paralelas como o 2º Encontro Regional de Turismo e o Salão de Noivas e Festas, no Country Clube.',
    eventSlug: 'fepro',
    image:
      'https://www.portalmultiplix.com/rails/active_storage/representations/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBdnhhIiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--b80f5b182ce1d6de03382f6098a44ef86c2f7e2b/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaDdCam9MY21WemFYcGxTU0lKTVRBeU5BWTZCa1ZVIiwiZXhwIjpudWxsLCJwdXIiOiJ2YXJpYXRpb24ifX0=--225ee2b8fdfbf7a081fbd41b5290b3252f18a8c0/FEPRO%202025%20portal.jpg',
    date: '2025-04-08',
    dateLabel: 'Abril 2025',
    source: 'Portal Multiplix',
    url: 'https://www.portalmultiplix.com/noticias/economia/fepro-2025-comeca-nesta-quarta-feira-em-friburgo-com-shows-encontro-de-turismo-e-promocoes',
  },
  {
    id: 'fepro-2025-edicao-historica-celebra-25-anos-com-muitas-novidades',
    title: 'Fepro 2025: Edição histórica celebra 25 anos com muitas novidades',
    summary:
      'Prepare-se para a maior edição da Feira da Promoção de Nova Friburgo! De 9 a 13 de abril, o Country Clube será a casa de uma edição comemorativa dos 25 anos do evento, reunindo promoções imperdíveis, uma programação musical recheada e o melhor do comércio e turismo do interior do Rio de Janeiro.',
    eventSlug: 'fepro',
    image:
      'https://novafriburgoemfoco.com.br/wp-content/uploads/2025/04/feprofoto-700x328.jpg.webp',
    date: '2025-04-02',
    dateLabel: 'Abril 2025',
    source: 'Nova Friburgo em Foco',
    url: 'https://novafriburgoemfoco.com.br/fepro-2025-edicao-historica-celebra-25-anos-com-muitas-novidades/',
  },
];

export function getLatestNews(count = 3): NewsArticle[] {
  return [...news]
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, count);
}
